module.exports = __webpack_public_path__ + "img/551-v.7a8c0c67.png";